import React, { useState } from "react";
import { Box, Button, FormControl, MenuItem, Select, Stack, Typography } from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import MaterialModal from "../../../../app/material-modal";
import { CohortRoles, UserRoles } from "../../../../../constants";

export function AddRoleModal({
  open,
  handleClose,
  inviteList,
  setInviteList,
  selectedInviteUserData,
  cohortTeamList,
}) {
  const [selectedGroup, setSelectedGroup] = useState("");
  const [selectedRole, setSelectedRole] = useState("");

  const roles = selectedGroup
    ? selectedGroup?.groupType === "Cohort"
      ? Object.values(CohortRoles)
      : Object.values(UserRoles)
    : [];

  const handleSubmit = (e) => {
    e.preventDefault();

    const newInviteList = {
      ...inviteList,
      data: [...inviteList?.data],
    };

    selectedInviteUserData.forEach((user) => {
      const idx = newInviteList.data.findIndex(item => item._id === user._id);
      if (idx !== -1) {
        newInviteList.data[idx] = {
          ...newInviteList.data[idx],
          roles: [{
            id: selectedGroup?.id || uuidv4(),
            groupID: selectedGroup?.groupID || "",
            groupName: selectedGroup?.name || "",
            roleName: selectedRole || "",
          }],
        };
      }
    });

    setInviteList(newInviteList);
    setSelectedGroup("");
    setSelectedRole("");
    handleClose();
  };

  return (
    <MaterialModal
      open={open}
      handleDialogClose={handleClose}
      styleOverrides={{
        container: {
          "& .MuiDialog-paper": {
            width: "100%",
            minHeight: "250px",
            maxWidth: "450px",
            ".MuiDialogContent-root": { overflow: "auto" },
          },
        },
      }}
      title="Add Role"
    >
      <form onSubmit={handleSubmit}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Stack direction="row" gap={3}>
            <Typography variant="body1" sx={{ flexBasis: "40%" }}>Select Group*</Typography>
            <FormControl size="small" fullWidth>
              <Select
                value={selectedGroup}
                required
                onChange={(event) => {
                  setSelectedGroup(event.target.value);
                  setSelectedRole("");
                }}
                sx={{ border: 0 }}
                displayEmpty
                renderValue={(val) => {
                  return  val ? <em>{val?.name}</em> : <em>Select Group</em>;
                }}
              >
                <MenuItem value={null} disabled>Select Group</MenuItem>
                {cohortTeamList?.map((group, idx) => (
                  <MenuItem key={idx} value={group}>{group?.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>

          <Stack direction="row" gap={3}>
            <Typography variant="body1" sx={{ flexBasis: "40%" }}>Select Role*</Typography>
            <FormControl size="small" fullWidth>
              <Select
                 value={selectedRole}
                 onChange={(event) => {
                   setSelectedRole(event.target.value);
                 }}
                 required
                 displayEmpty
                 sx={{ border: 0 }}
                 renderValue={(val) => {
                   return  val ? <em>{val}</em> : <em>Select Role</em>;
                 }}
              >
                <MenuItem value="" disabled>Select Role</MenuItem>
                {roles.map((role, idx) => (
                  <MenuItem
                    key={idx}
                    value={role}
                    disabled={["Administrator", "SystemAdministrator"].includes(role)}
                  >
                    {role}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 2 }}>
            <Button variant="outlined" onClick={handleClose}>Cancel</Button>
            <Button variant="contained" type="submit">Save</Button>
          </Box>
        </Box>
      </form>
    </MaterialModal>
  );
}
